
import Vue from 'vue';
import { Author } from '@root/modules/article/types/article';
import getAliasByLocale from '@root/common/utils/getAliasByLocale';
import { TranslateResult } from 'vue-i18n';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import AuthorImage from '@root/views/authors/components/AuthorImage.vue';

interface Props {
  author: Author;
  showTitle: boolean;
  showPictureEmail: boolean;
  showInfo: boolean;
}

interface Computed {
  title: string;
  email: string | null;
  role: TranslateResult;
  authorLink: string;
  picture: string;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    LinkHandler,
    AuthorImage,
  },
  props: {
    author: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: () => true,
      required: false,
    },
    showPictureEmail: {
      type: Boolean,
      default: () => true,
      required: false,
    },
    showInfo: {
      type: Boolean,
      default: () => true,
      required: false,
    },
  },
  computed: {
    title() {
      return this.author?.attributes?.description || '';
    },
    email() {
      const showEmail = this.showTitle && !this.title && this.author?.attributes?.email;
      return showEmail ? this.author?.attributes?.email || null : null;
    },
    role() {
      return this.$te(`article.author_roles.${this.author?.attributes?.role}`) ? this.$t(`article.author_roles.${this.author?.attributes?.role}`) : '';
    },
    authorLink() {
      const authorId = this.author.employeeId;
      const authorSlug = this.author.slug;

      if (!authorId) {
        return '';
      }

      const path = getAliasByLocale(this.$channelConfig('settings').locale, 'author');
      return `/${path}/${authorId}/${authorSlug}`;
    },
    picture() {
      return this.author?.image?.id || '';
    },
  },
});
